import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    user: null,
    token: null,
    refreshToken: null,
    isAuthenticated: false,
    isLoading: true,
    permissions: [],
    lastLogin: null
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        loginSuccess: (state, action) => {
            const { user, token, refreshToken } = action.payload;
            state.user = user;
            state.token = token;
            state.refreshToken = refreshToken;
            state.isAuthenticated = true;
            state.isLoading = false;
            state.lastLogin = new Date().toISOString();
            
            // Store permissions based on user role
            const permissions = {
                superadmin: ['*'],
                landlord: ['view_dashboard', 'manage_assets', 'manage_leases', 'view_payments', 'manage_maintenance'],
                caretaker: ['view_dashboard', 'view_assets', 'manage_maintenance', 'view_leases', 'record_payments'],
                tenant: ['view_my_lease', 'make_payments', 'request_maintenance', 'view_my_payment_history']
            };
            state.permissions = permissions[user.role] || [];
            
            // Persist to localStorage
            localStorage.setItem('token', token);
            localStorage.setItem('refreshToken', refreshToken);
            localStorage.setItem('user', JSON.stringify(user));
        },
        updateUser: (state, action) => {
            state.user = { ...state.user, ...action.payload };
            localStorage.setItem('user', JSON.stringify(state.user));
        },
        updateToken: (state, action) => {
            state.token = action.payload;
            localStorage.setItem('token', action.payload);
        },
        logout: (state) => {
            state.user = null;
            state.token = null;
            state.refreshToken = null;
            state.isAuthenticated = false;
            state.isLoading = false;
            state.permissions = [];
            state.lastLogin = null;
            
            localStorage.removeItem('token');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('user');
            localStorage.removeItem('tenant');
        },
        restoreSession: (state) => {
            const token = localStorage.getItem('token');
            const refreshToken = localStorage.getItem('refreshToken');
            const user = localStorage.getItem('user');
            
            if (token && user) {
                state.token = token;
                state.refreshToken = refreshToken;
                state.user = JSON.parse(user);
                state.isAuthenticated = true;
                
                const permissions = {
                    superadmin: ['*'],
                    landlord: ['view_dashboard', 'manage_assets', 'manage_leases', 'view_payments', 'manage_maintenance'],
                    caretaker: ['view_dashboard', 'view_assets', 'manage_maintenance', 'view_leases', 'record_payments'],
                    tenant: ['view_my_lease', 'make_payments', 'request_maintenance', 'view_my_payment_history']
                };
                state.permissions = permissions[state.user.role] || [];
            }
            state.isLoading = false;
        },
        setPermissions: (state, action) => {
            state.permissions = action.payload;
        }
    }
});

// Export all actions
export const { 
    setLoading, 
    loginSuccess, 
    updateUser, 
    updateToken, 
    logout, 
    restoreSession,
    setPermissions
} = authSlice.actions;

// Export the reducer as default
export default authSlice.reducer;